import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const Footer = () => {
    return (
        <Box sx={{ backgroundColor: '#333', color: 'white', padding: '10px 0' }}>
            <Container>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
                    <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                        &copy; {new Date().getFullYear()} Glassyfied
                    </Typography>
                    <Link href="/about" color="inherit" sx={{ fontSize: '0.9rem' }}>About</Link>
                    <Link href="/terms" color="inherit" sx={{ fontSize: '0.9rem' }}>Terms</Link>
                    <Link href="/privacy" color="inherit" sx={{ fontSize: '0.9rem' }}>Privacy</Link>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
